
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkin",
      function () {
        return require("private-next-pages/checkin.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkin"])
      });
    }
  